export enum SynchronizationType {
  Diff = 0,
  Full = 1,
}
